/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

import { html, LitElement } from 'lit-element';
import { sharedStyles } from '../../styles';
import { dispatchCustomEvent } from '../../utils/custom-event-dispatcher.js';
import tagStyles from './sh-tag.lit.scss.js';

/**
 * @prop {String} label - Default Label. Defines the label shown on the tag.
 * @prop {Boolean} selectable -Defines whether the tag is selected or not.
 * @prop {Boolean} removable - Default false.Defines whether a tag can be removed or not. Adds a close icon next to the tag.
 * @prop {Boolean} removable - Default false.Defines whether a tag can be removed or not. Adds a close icon next to the tag.
 * @prop {Boolean} active - Active state of tag.
 * @prop {Boolean} disabled - Default false. If set to `true`, will update the styles and disable pointer events.
 * @fires closed - Dispatched when clicking on the "close" icon.
 */
export class SHTag extends LitElement {
  static get properties() {
    return {
      label: { type: String, reflect: true },
      selectable: { type: Boolean, reflect: true },
      active: { type: Boolean, reflect: true },
      removable: { type: Boolean, reflect: true },
      disabled: { type: Boolean, reflect: true },
    };
  }
  static get styles() {
    return [sharedStyles, tagStyles];
  }

  render() {
    return html`
      <div class="tag-wrapper" ?disabled="${this.disabled}" @click="${this._onClickTag}">
        <span class="tag-label">${this.label}</span>
        ${this.removable
          ? html`<sh-icon
              id="clear"
              button=""
              icon="cancel"
              size="xs"
              @click="${this._onRemoveTag}"
              tabindex="${!this.disabled ? '0' : '-1'}"
            ></sh-icon>`
          : ''}
      </div>
    `;
  }

  constructor() {
    super();
    this.label = 'Label';
  }

  _onRemoveTag() {
    //custom event for close tag
    if (!this.disabled) {
      dispatchCustomEvent(this, 'closed');
    }
  }

  _onClickTag() {
    if (this.selectable) {
      this.active = !this.active;
    }
  }
}

customElements.define('sh-tag', SHTag);
